<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-left"
    width="44%"
    side="left"
    body-class="bbSidePanelBody bbSidePanelBody-Combatant"
    footer-class="bbSidePanelFooter"
    :z-index="5000"
  >
    <!-- <template #header>
      <div :style="myStyles">
        <div class="row">
          <div class="col">
            <p class="bb-page-title">COMBATANT</p>
          </div>
          <div class="col" style="background-color: red;">
            <p>{{ combatant.race.image }}</p>
          </div>
        </div>
      </div>
    </template> -->
    <template #default>
      <div class="mt-2 px-4">
        <CombatantCard
          :combatant="combatant"
          :combatantNames="combatantNames"
        />
      </div>
    </template>
    <!-- <template #footer>
      <div>
        <h2>This is fixed footer!</h2>
      </div>
    </template> -->
  </VueSidePanel>
</template>

<script>
import CombatantCard from './CombatantCard.vue'
import { VueSidePanel } from 'vue3-side-panel'
// import "vue3-side-panel/dist/vue3-side-panel.css";
//----------------------
// scripts
//----------------------
export default {
  name: 'CombatantSidePanel',
  //----------------------
  // components
  //----------------------
  components: {
    VueSidePanel,
    CombatantCard,
  },
  //----------------------
  // props
  //----------------------
  props: {
    combatant: {
      type: Object,
      required: false,
      default: null,
    },
    combatantNames: {
      type: Array,
      required: true,
      default: null,
    },
    // sidePanelHeight: {
    //   type: Number,
    //   required: true,
    // },
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      isSidePanelOpen: true,
    }
  },
  //----------------------
  // computed
  //----------------------
  watch: {
    isSidePanelOpen(newValue) {
      if (!newValue) {
        this.emitter.emit('close-combatant-side-panel', false)
      }
    },
  },
  //----------------------
  // methods
  //----------------------
  methods: {},
  //----------------------
  // mounted
  //----------------------
  mounted() {
    this.emitter.on('close-combatant-side-panel', (ind) => {
      this.isSidePanelOpen = ind
    })
  },
}
</script>

<style>
.bbSidePanelBody-Combatant {
  overflow-x: visible !important;
}

.vsp-overlay {
  background: #1e1e1e !important;
  opacity: 0.6 !important;
}
</style>
